export const VERSION = MICROBUNDLE_CURRENT_VERSION || "TESTVERSION"
